<template>
  <div class="w-96 md:w-full h-full">
    <div class="w-full flex">
      <vs-slider :min="minSlider" :max="slider" color="rgb(45, 208, 129)" v-model="counter" />
      <div class="border rounded ml-3 flex justify-center items-center px-2">
        {{ counter }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    question: {
      type: Object,
      required: true
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      slider: this.question.properties.maxValue,
      minSlider: parseInt(this.question.properties.minValue)
    };
  },  
  computed: {
    counter: {
      get() {
        return parseInt(this.value) || parseInt(this.question.properties.minValue);
      },
      set(value) {
        this.change(String(value), { ...this.Item, answer: String(value) });
        this.$emit("input", String(value));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-slider {
  display: flex !important;
}
</style>
